import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/pic_search.png';
import _imports_1 from '@/assets/imgs/pic_edit.png';
import _imports_2 from '@/assets/imgs/pic_del.png';

const _withScopeId = n => (_pushScopeId("data-v-7c6173c3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "upload_area"
};
const _hoisted_2 = {
  class: "upload-area"
};
const _hoisted_3 = {
  key: 1,
  class: "avatar-uploader"
};
const _hoisted_4 = {
  class: "operation"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "upload-tips"
};
const _hoisted_7 = {
  class: "sm_upload_area"
};
const _hoisted_8 = {
  key: 1,
  class: "sm_avatar_uploader"
};
const _hoisted_9 = {
  class: "operation"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "sm_upload_tips"
};
const _hoisted_12 = ["src", "alt"];
import { Plus } from '@element-plus/icons-vue';
import { nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import UploadPicDialog from './uploadPicDialog.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'uploadForm',
  props: {
    picObj: {
      default: () => {},
      type: Object || Array
    },
    mode: {
      // 上级表单的模式 add||edit
      default: 'add',
      type: String
    }
  },
  emits: ['update:bigIcon', 'updatePicObj'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const mform = ref();
    const formModel = ref({
      bigIcon: {
        fileURL: '',
        name: '',
        newName: '',
        size: 0
      },
      smIcon: {
        fileURL: '',
        name: '',
        newName: '',
        size: 1
      }
    });
    expose({
      mform
    });
    const bigPicData = reactive({
      visible: false,
      url: ''
    }); // watch(()=>props.mode, (newVal,oldVal)=> {
    //   console.log('传输组件的数据', props.picObj)
    //   if(props.mode==='edit') {
    //     formModel.value = props.picObj
    //   }
    // },{immediate:true, deep:true})

    watch(() => props.picObj, newVal => {
      console.log('组件传入的数据', newVal);

      if (props.mode === 'edit') {
        formModel.value = props.picObj;
        console.log('ZZZ', formModel.value);
      }
    }, {
      immediate: true,
      deep: true
    });
    const dialogObj = reactive({
      dialogVisible: false,
      title: '上传图片',
      width: '30%',
      successBtnText: '确定',
      closeBtnText: '取消',
      isFooter: true,
      row: {},
      type: 0 // 区分上传大图标还是小图标 0大图标 1小图标

    });

    const previewBigPic = type => {
      // type:0 大图标 1 小图标
      //查看大图
      bigPicData.visible = true;
      bigPicData.url = type === 0 ? formModel.value.bigIcon.fileURL : formModel.value.smIcon.fileURL;
      console.log('big', bigPicData.url);
    };

    const deletePic = (data, type) => {
      // 删除图片
      bigPicData.visible = false;
      bigPicData.url = '';
      dialogObj.row = {};

      if (type === 0) {
        formModel.value.bigIcon.fileURL = '';
        formModel.value.bigIcon.name = '';
      } else {
        formModel.value.smIcon.fileURL = '';
        formModel.value.smIcon.name = '';
      }

      emit('updatePicObj', [formModel.value.bigIcon, formModel.value.smIcon]);
      nextTick(() => {
        //手动触发图片区域的校验
        mform.value.validate((valid, fields) => {});
      });
    };

    const validImg = (rule, value, callback) => {
      //if(!value.fileURL || value.fileURL==='') return callback(new Error(t('请上传图片')))
      callback();
    };

    const imgRules = reactive({
      bigIcon: [{
        required: false,
        validator: validImg,
        trigger: 'change'
      }],
      smIcon: [{
        required: false,
        validator: validImg,
        trigger: 'change'
      }]
    }); // 打开对话框上传图片

    const uploadPic = type => {
      //type: 0 大图标 1 小图标
      dialogObj.type = type;
      dialogObj.row = type === 0 ? formModel.value.bigIcon.fileURL : formModel.value.smIcon.fileURL;
      dialogObj.dialogVisible = true;
    }; // 编辑图片


    const onEditPic = (data, type) => {
      console.log('编辑图片', data, type);
      dialogObj.type = type;
      dialogObj.dialogVisible = true;
      dialogObj.row = data;
    }; // 关闭弹框


    const dialogClose = () => {
      dialogObj.dialogVisible = false;
    }; // 确认弹框


    const dialogSuccess = (picData, type) => {
      dialogObj.dialogVisible = false;

      if (type === 0) {
        formModel.value.bigIcon.fileURL = picData.fileURL;
        formModel.value.bigIcon.name = picData.name;
        formModel.value.bigIcon.newName = picData.newName;
      } else {
        formModel.value.smIcon.fileURL = picData.fileURL;
        formModel.value.smIcon.name = picData.name;
        formModel.value.smIcon.newName = picData.newName;
      } //更新数据


      emit('updatePicObj', [formModel.value.bigIcon, formModel.value.smIcon]);
      nextTick(() => {
        //手动触发图片区域的校验
        if (type === 0) {
          mform.value.validateField('bigIcon', (valid, fields) => {});
        } else {
          mform.value.validateField('smIcon', (valid, fields) => {});
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "mform",
        ref: mform,
        model: formModel.value,
        rules: imgRules,
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "bigIcon",
          ref: "imgItemRef",
          class: "bg_form"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [!formModel.value.bigIcon.fileURL ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "avatar-uploader",
            onClick: _cache[0] || (_cache[0] = $event => uploadPic(0))
          }, [_createVNode(_component_el_icon, {
            class: "avatar-uploader-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: _cache[1] || (_cache[1] = $event => previewBigPic(0))
          }), _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            onClick: _cache[2] || (_cache[2] = $event => onEditPic(formModel.value.bigIcon, 0))
          }), _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            onClick: _cache[3] || (_cache[3] = $event => deletePic(formModel.value.bigIcon, 0))
          })]), _createElementVNode("img", {
            src: formModel.value.bigIcon.fileURL,
            class: "avatar"
          }, null, 8, _hoisted_5)])), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('频道图标')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('大尺寸')) + ": 200*200px", 1)])])]),
          _: 1
        }, 512), _createVNode(_component_el_form_item, {
          prop: "smIcon",
          ref: "imgItemRef",
          class: "sm_form"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [!formModel.value.smIcon.fileURL ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "sm_avatar_uploader",
            onClick: _cache[4] || (_cache[4] = $event => uploadPic(1))
          }, [_createVNode(_component_el_icon, {
            class: "avatar-uploader-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: _cache[5] || (_cache[5] = $event => previewBigPic(1))
          }), _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            onClick: _cache[6] || (_cache[6] = $event => onEditPic(formModel.value.smIcon, 1))
          }), _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            onClick: _cache[7] || (_cache[7] = $event => deletePic(formModel.value.smIcon, 1))
          })]), _createElementVNode("img", {
            src: formModel.value.smIcon.fileURL,
            class: "sm_avatar"
          }, null, 8, _hoisted_10)])), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('频道图标')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('小尺寸')) + ": 60*60px", 1)])])]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["model", "rules"])]), _createVNode(_component_el_dialog, {
        modelValue: bigPicData.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => bigPicData.visible = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          style: {
            "width": "100%"
          },
          "w-full": "",
          src: bigPicData.url,
          alt: _ctx.$t('Preview Image')
        }, null, 8, _hoisted_12)]),
        _: 1
      }, 8, ["modelValue"]), dialogObj.dialogVisible ? (_openBlock(), _createBlock(UploadPicDialog, {
        key: 0,
        "dialog-object": dialogObj,
        type: dialogObj.type,
        onDialogClose: dialogClose,
        onDialogSuccess: dialogSuccess
      }, null, 8, ["dialog-object", "type"])) : _createCommentVNode("", true)], 64);
    };
  }

});